module.exports = __webpack_public_path__ + "assets/invite-students.318df357.svg";